<template>
	<select :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" v-cloak>
		<option v-if="showNull" :value="null">{{nullText}}</option>
		<option v-for="(option, i) in optionsArray" :key="getValue(option)" :value="getValue(option)" :selected="getSelected(option)">{{getName(option)}}</option>
	</select>
</template>




<script>
	export default {
		emits: ['update:modelValue'],
		data: () => ({
		}),
		props: {
			options:    { type: [Array, Object], required: false, default: () => (null) },
			modelValue: { type: [Number, Boolean, String], required: false, default: 0 },
			valueProp:  { type: String, required: false, default: 'value' },
			nameProp:   { type: String, required: false, default: 'name' },
			showNull:   { type: Boolean, required: false, default: false },
			nullText:   { type: String, required: false, default: '[None]' }
		},
		methods: {
			getValue(option) {
				return option[this.valueProp];
			},
			getName(option) {
				return option[this.nameProp];
			},
			getSelected(option) {
				// this thing doesn't init to v-modeled value, so we do it like this
				var optionValue = this.getValue(option);
				return (this.modelValue == optionValue);
			},
			optionsArrayFromObject(obj) {
				delete obj['$id'];
				return Object.values(obj);
			}
		},
		computed: {
			optionsArray() {
				var isArr   = Array.isArray(this.options);
				var notNull = (this.options != null);

				return (isArr)
					? this.options // return as is
					: (notNull)
					? this.optionsArrayFromObject(this.options)
					: [];
			}
		}
	};
</script>




<style scoped>
	[v-cloak] {
		display:none;
	}
</style>